/**
 * A constant object that defines event names used throughout the {@link EventService}.
 *
 * This object acts as a central repository for all predefined event names, ensuring consistency
 * when emitting and subscribing to events in the {@link EventService}.
 *
 */
export const EventName = {
  NAVIGATION_END: 'navigationEnd',
  NAVIGATION_START: 'navigationStart',
  LOGIN: 'login',
  LOGOUT: 'logout',
  APP_DATA_LOADED: 'applicationDataLoaded',
  APPLICATION_MOUNTED: 'applicationMounted',
  APPLICATION_UNMOUNTED: 'applicationUnmounted',
  APPLICATION_CHANGED: 'applicationChanged',
  APPLICATION_BEFORE_CHANGE: 'applicationBeforeChange'
};
